<template>
  <div>
    <div class="iap-header-div">
      <h4>IAP product ids</h4>
      <div class="iap-add-new-div">
        <v-btn
          variant="flat"
          color="accent"
          :disabled="disabled"
          @click.stop="openNewProductDialog()"
        >
          <v-icon start>md:add</v-icon>Add product id
        </v-btn>
      </div>
    </div>
    <v-dialog v-model="productsDialog" width="500" persistent>
      <v-card>
        <v-card-title>Add product ID</v-card-title>
        <v-card-text>
          <RfTextInput
            v-model="editingProduct.name"
            variant="outlined"
            density="compact"
            title="Name"
            placeholder="Name"
          />
          <RfTextInput
            v-model="editingProduct.product_id"
            variant="outlined"
            density="compact"
            title="Product ID"
            placeholder="Product ID"
            hideDetails
          />
        </v-card-text>
        <v-card-actions class="modal-card-actions-div">
          <v-btn class="cancel-btn px-7!" variant="outlined" @click.stop="productsDialog = false"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            class="px-10!"
            variant="flat"
            :disabled="!submitProductEnabled"
            @click="submitProduct"
            >{{ submitProductCTA }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-table class="rf-settings-table-data">
      <thead>
        <tr>
          <th width="41%">Name</th>
          <th width="41%">Product Id</th>
          <th width></th>
        </tr>
      </thead>
      <tbody v-if="productsDisplay.length">
        <tr v-for="(product, index) in productsDisplay" :key="index">
          <td>{{ product.name }}</td>
          <td>{{ product.product_id }}</td>
          <td>
            <div class="settings-button-wrapper">
              <v-btn size="small" :disabled="disabled" @click="editProduct(index)">
                <v-icon color="accent" size="24">md:edit</v-icon>
              </v-btn>
              <v-btn size="small" :disabled="disabled" @click="deleteProduct(index)">
                <v-icon color="error" size="24">md:clear</v-icon>
              </v-btn>
            </div>
          </td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr>
          <td>
            <div>No product ids configured. Add a product id.</div>
          </td>
        </tr>
      </tbody>
    </v-table>
  </div>
</template>

<script>
import RfTextInput from "@/components/legacy/RfInputLegacy.vue";
import { cloneDeep } from "lodash-es";

export default {
  name: "RfAppleProductIds",
  components: { RfTextInput },
  props: ["app", "disabled"],
  data() {
    return {
      productsDialog: false,
      newProduct: {
        product_id: "",
        name: "",
      },
      editProductIndex: -1,
      editingProduct: {},
      computeKey: 0,
    };
  },
  computed: {
    submitProductCTA() {
      if (this.editProductIndex >= 0) {
        return "Update Product ID";
      }
      return "Add Product ID";
    },
    submitProductEnabled() {
      return !!(this.editingProduct.name && this.editingProduct.product_id);
    },
    productsDisplay() {
      this.computeKey;
      return this.app.providers.apple.product_ids;
    },
  },
  methods: {
    editProduct(index) {
      this.editingProduct = cloneDeep(this.app.providers.apple.product_ids[index]);
      this.editProductIndex = index;
      this.productsDialog = true;
    },
    deleteProduct(index) {
      this.app.providers.apple.product_ids.splice(index, 1);
      this.computeKey++;
    },
    openNewProductDialog() {
      this.editingProduct = cloneDeep(this.newProduct);
      this.productsDialog = true;
    },
    submitProduct() {
      if (this.editProductIndex >= 0) {
        this.app.providers.apple.product_ids[this.editProductIndex] = this.editingProduct;
      } else {
        this.app.providers.apple.product_ids.push(this.editingProduct);
      }
      this.editingProductIndex = -1;
      this.productsDialog = false;
    },
  },
};
</script>
<style scoped>
.iap-header-div {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 20px 0;
}
.iap-header-div > h4 {
  font-size: 1.3em;
  color: #383938;
}
.iap-header-div > h4,
.iap-header-div > div {
  flex: 1;
}
.iap-header-div > div {
  text-align: right;
}
</style>
